export default __webpack_public_path__ + "static/media/mobilePhone.ba6e67d1.png";